module.exports = __webpack_public_path__ + "assets/img/2.bb9fde72.jpg";